export default __webpack_public_path__ + "static/media/nft-5.2d6d8e1c.png";